import React from "react"
import PropTypes from "prop-types"
import dateTimeWithTimeFormat from '../utils/dateTimeWithTimeFormat'

class ConvoTeaserItem extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
    }

    this.otherUserImg = this.otherUserImg.bind(this)
    this.otherUserName = this.otherUserName.bind(this)
  }

  otherUserImg() {
    return this.props.currentUser.id === this.props.convo.sender.id ? (this.props.convo.recipient.avatar_url === "medium/missing.png" ? this.props.missingImg : this.props.convo.recipient.avatar_url) : (this.props.convo.sender.avatar_url === "medium/missing.png" ? this.props.missingImg : this.props.convo.sender.avatar_url)
  }

  otherUserName() {
    return this.props.currentUser.id === this.props.convo.sender.id ? this.props.convo.recipient.preferred_name : this.props.convo.sender.preferred_name
  }

  render() {
    const { convo } = this.props
    const unread = ((this.props.currentUser.id != convo.last_msg.user_id) && !convo.last_msg.read)
    return(
      <div className="wrapper_convo" onClick={() => this.props.openConvo(convo.id)}>
        {unread && <p className="unread-messages notif_right">NEW!</p>}
        <div style={{display: 'flex', flexDirection: 'row'}}>
          <img src={this.otherUserImg()} className="avatar_standard" />
          <div style={{marginLeft: 15}}>
            <h5 style={{fontWeight: 600, marginBottom: 10}}>{this.otherUserName()}</h5>
            <h5>{convo.last_msg.body}</h5>
          </div>
        </div>
        <p style={{textAlign: 'right'}}>{dateTimeWithTimeFormat(convo.last_msg.created_at)}</p>
      </div>
    )
  }

}

export default ConvoTeaserItem;
